module.exports = __webpack_public_path__ + "static/media/MSungHK-Light.41224f8a.svg";